import './App.css';
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import WorkExperience from './components/Work_Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem('mode');
    return savedMode ? JSON.parse(savedMode) : true;
  });

  const changeMode = () => {
    setMode(prevMode => !prevMode);
  };

  useEffect(() => {
    if (mode) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.add('light-mode');
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('mode', JSON.stringify(mode));
  }, [mode]);

  return (
    <div className={`app-shell ${mode ? 'theme-dark' : 'theme-light'}`}>
      <Navbar toggleMode={changeMode} mode={mode} />

      <main className="site-main">
        <section id="home" className="page-section hero-section">
          <Hero mode={mode} />
        </section>

        <section id="about" className="page-section">
          <About mode={mode} />
        </section>

        <section id="skills" className="page-section">
          <Skills mode={mode} />
        </section>

        <section id="projects" className="page-section">
          <Projects mode={mode} />
        </section>

        <section id="experience" className="page-section">
          <WorkExperience mode={mode} />
        </section>

        <section id="contact" className="page-section">
          <Contact mode={mode} />
        </section>
      </main>

      <Footer mode={mode} />
    </div>
  );
}

export default App;
